module.exports = __webpack_public_path__ + "img/42f7824.jpg";